<template>
  <div class="slide" :id="'slide_q_'+question" v-if="isVisibleSlide('q_'+question)">
    <div class="intro" v-if="question == 0">
      <h1>Take the Test: How Good Are Your First Aid Skills?</h1>
      <h2>Getting first aid right is vital, but how good is your knowledge? Test yourself now - it takes two minutes:</h2>
    </div>
    <div class="slide-content" :class="{first: question == 0}">
      <!-- Defaut question template -->
      <div class="container question-container" v-if="q.type == 'text'">
        <div class="row">
          <div class="col-lg-6 quiz-image desktop-only" :class="['quiz-image-' + question]">
            <img :src="require('@/assets/img/q_'+question+'.jpg')" />
          </div>
          <div class="col-lg-6 quiz-content">
            <div class="quiz-progress">
              <div class="quiz-progress-label">{{question + 1}} of {{$store.state.questions.length}}</div>
              <div class="quiz-progress-bar" :style="{ 'width': (100/7)*(question + 1) + '%' }"></div>
            </div>
            <img
              :src="require('@/assets/img/qm_'+question+'.jpg')"
              class="mobile-quiz-image mobile-only"
              v-if="question != 0"
            />
            <div class="quiz-content-wrapper">
              <div class="quiz-question">{{q.text}}</div>
              <div class="buttons-container">
                <button
                  class="btn btn-light"
                  :class="{active: o.text == q.userAnswer}"
                  @click="answerQuestion(question, o)"
                  :key="oindex"
                  v-for="(o, oindex) in q.options"
                >{{ o.text }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Images question template -->
      <div class="container question-container" v-if="q.type == 'img'">
        <div class="row">
          <div class="col-lg-12 quiz-content">
            <div class="quiz-progress">
              <div class="quiz-progress-label">{{question + 1}} of {{$store.state.questions.length}}</div>
              <div class="quiz-progress-bar" :style="{ 'width': (100/7)*(question + 1) + '%' }"></div>
            </div>
            <div class="quiz-content-wrapper quiz-content-wrapper-img">
              <div class="quiz-question">{{q.text}}</div>
              <div class="buttons-container">
                <button
                  class="btn btn-light btn-img"
                  :class="[{active: o.text == q.userAnswer},{inactive:  o.text != q.userAnswer && q.userAnswer != null}]"
                  @click="answerQuestion(question, o)"
                  :key="oindex"
                  v-for="(o, oindex) in q.options"
                >
                  <img :src="require('@/assets/img/q_'+question+'_'+o.text+'.jpg')" />
                  <div class="btn-img-text">{{ o.text }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: ["gotoSlide", "isVisibleSlide", "question", "analytics"],
  data() {
    return {
      nextQuestion: parseInt(this.question) + 1,
      q: this.$store.state.questions[this.question]
    };
  },
  methods: {
    answerQuestion(question, choice) {
      this.$store.commit("answerQuestion", { question, choice });
      if (this.nextQuestion > this.$store.state.questions.length - 1) {
        this.gotoSlide("before_results");
      } else {
        this.gotoSlide("q_" + this.nextQuestion);
      }
      var questionN = parseInt(question) + 1;
      this.analytics("question " + questionN, "answered " + choice.text);
    }
  }
};
</script>

<style scoped lang="scss">
.intro {
  margin-bottom: 0px;
  padding: 100px 20px 80px 20px;
  background: #a80000;
  color: #fff;
  background-image: url("../assets/img/red-bg.jpg");
  background-size: cover;
  @media only screen and (max-width: 768px) {
    margin-bottom: 0px;
    padding: 50px 20px;
  }
  h1 {
    font-size: 19px;
    font-weight: 600;
  }
  h2 {
    font-size: 19px;
    margin-top: 20px;
  }
}
.question-container {
  box-shadow: 2px 2px 10px rgba(70, 70, 70, 0.1);
  margin-top: 50px;
  @media only screen and (max-width: 768px) {
    margin-top: 0px;
    box-shadow: none;
    width: 100%;
    max-width: 800px;
  }
}
.first .question-container {
  margin-top: 0px;
}
.quiz-image {
  text-align: center;
  padding: 0;
  img {
    max-width: 100%;
  }
}
.quiz-progress {
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  padding-left: 80px;
  height: 40px;
  background: #ebebeb;
  @media only screen and (max-width: 768px) {
    margin-bottom: 0px;
  }
  .quiz-progress-label {
    position: absolute;
    left: 0;
    width: 80px;
    height: 40px;
    background: #333333;
    color: #fff;
    text-align: center;
    padding: 10px 0;
    font-size: 13px;
  }
  .quiz-progress-bar {
    width: 30%;
    height: 40px;
    background-image: url("../assets/img/progress.jpg");
    background-size: cover;
  }
}
.quiz-content {
  text-align: left;
  padding: 0;
  @media only screen and (max-width: 768px) {
    text-align: center;
    margin-top: 0px;
  }
  .quiz-content-wrapper {
    padding: 20px;
    text-align: left;
    margin: 60px auto 20px auto;
    max-width: 360px;
    @media only screen and (max-width: 768px) {
      margin: 20px auto 20px auto;
    }
    .quiz-question {
      margin-bottom: 40px;
      font-size: 17px;
      @media only screen and (max-width: 768px) {
        text-align: center;
      }
    }
    &.quiz-content-wrapper-img {
      max-width: 100%;
      text-align: center;
      .quiz-question {
        margin-bottom: 20px;
      }
    }
  }
}
.buttons-container {
  button {
    display: block;
    margin: 10px auto;
    background: #ebebeb;
    border-radius: 0;
    font-size: 17px;
    padding: 15px;
    width: 100%;
    font-weight: normal;
    white-space: normal;
    color: #7d7d7d;
    &:hover {
      color: #fff;
    }
    &.active {
      background: #cd171e !important;
      color: #fff !important;
    }
  }
  .btn-img {
    display: inline-block;
    padding: 0;
    width: 30%;
    margin: 20px 1%;
    @media only screen and (max-width: 768px) {
      width: 100%;
      margin: 15px 0;
    }
    img {
      width: 100%;
    }
    .btn-img-text {
      padding: 15px;
    }
    &.inactive {
      img {
        opacity: 1;
      }
    }
  }
}
/* Mobile fixes */
.first {
  .mobile-quiz-image {
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}
.mobile-quiz-image {
  width: 100%;
}
</style>